"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.max = exports.multiplier = exports.played = exports.digit = exports.all = void 0;
exports.all = true;
exports.digit = true;
exports.played = true;
exports.multiplier = true;
exports.max = true;
